import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";

import lessonServices from "../../../services/lessonServices";
import { getLanguage } from "../../../utils/getLanguage";
import DragAndDropGame from "../../games/DragAndDropGame";
import MemoryGame from "../../games/MemoryGame";
import PuzzleGame from "../../games/PuzzleGame";
import Modal from "../../Modal";

const TeacherGamesModal = forwardRef(({}, ref) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [gameDetails, setGameDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const lang = getLanguage();
  const [lessonID, setlessonID] = useState("");

  useImperativeHandle(ref, () => ({
    openModal(id) {
      setlessonID(id);
      setIsOpen(true);
    },
    closeModal() {
      handleCloseModal();
    },
  }));

  const handleCloseModal = () => {
    setIsOpen(false);
    formik.resetForm();
  };

  const fetchGame = async () => {
    setIsLoading(true);
    try {
      const data = await lessonServices.getLessonGames(lessonID);
      setGameDetails(data);
    } catch (err) {
      console.error("Failed to load game details:", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      fetchGame();
    }
  }, [lessonID, lang, isOpen]);

  return (
    <Modal isFullScreen isOpen={isOpen} onClose={handleCloseModal}>
      <>
        {gameDetails?.type === 1 && <MemoryGame gameDetails={gameDetails} />}
        {gameDetails?.type === 2 && <PuzzleGame gameDetails={gameDetails} />}
        {gameDetails?.type === 3 && <DragAndDropGame gameDetails={gameDetails} />}
      </>
    </Modal>
  );
});

export default TeacherGamesModal;
